import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { CountdownBlock } from './CountdownBlock';
import type { CountdownParts } from '../hooks/useCountdown';
type UrgencySectionProps = {
  parts: CountdownParts;
  spotsTaken?: number;
};
export function UrgencySection({
  parts,
  spotsTaken = 87
}: UrgencySectionProps) {
  return <section aria-label="Precio de lanzamiento" className="w-full bg-cream-100 py-14 sm:py-20" data-id="element-249" data-mp="31h4qddtrj885">
      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-250" data-mp="3ga88bmb9nnze">
        <Reveal data-id="element-251" data-mp="3b7zbgev9w1s0">
          <div className="rounded-[2rem] border-2 border-terracotta-300/50 bg-cream-50 p-7 text-center shadow-warm sm:p-10" data-id="element-252" data-mp="3b895qencov3i">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-terracotta-600 sm:text-sm" data-id="element-253" data-mp="3p6pionbt3hu3">
              ⏰ Precio de lanzamiento — cierra en:
            </p>

            <CountdownBlock parts={parts} data-id="element-254" data-mp="1uvau49uj7ofx" />

            <p className="mt-6 rounded-2xl bg-cream-200 px-5 py-3 text-sm font-semibold text-bark-800 sm:text-base" data-id="element-255" data-mp="1qt76kmul8tea">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>

            <div className="mt-7 text-left" data-id="element-256" data-mp="2srtomf4rzbad">
              <p className="text-sm font-semibold text-bark-800" data-id="element-257" data-mp="2xtsrlnwls66s">
                🔴 Cupos al precio de lanzamiento
              </p>
              <div role="progressbar" aria-valuenow={spotsTaken} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados" className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-cream-300" data-id="element-258" data-mp="32qj7ob8er1s7">
                <motion.div className="h-full rounded-full bg-terracotta-500" initial={{
                width: 0
              }} whileInView={{
                width: `${spotsTaken}%`
              }} viewport={{
                once: true
              }} transition={{
                duration: 1.1,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-259" data-mp="3gl3fdw7182ug" />
              </div>
              <p className="mt-2 text-xs font-medium text-bark-400 sm:text-sm" data-id="element-260" data-mp="1w4gloerygi7d">
                {spotsTaken}% de los cupos ya tomados
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}